import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const FaqLinkContainer = styled.div`
  position: fixed;
  top: 8px;
  right: 24px;
  z-index: 1000;

  ${theme.breakpoints.down('md')} {
    top: 4px;
    right: 16px;
  }
`

export const FaqLink = styled.button`
  background: none;
  border: none;
  color: #0088cc;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  padding: 8px 0;
  position: relative;
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    bottom: 6px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #f97316;
  }

  &:hover {
    color: #006699;
  }

  &:focus {
    outline: 2px solid #0088cc;
    outline-offset: 2px;
  }
`

export const DrawerContainer = styled.div`
  width: 400px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;

  ${theme.breakpoints.down('sm')} {
    width: 100vw;
  }
`

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0;
`

export const DrawerTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #374151;
  }

  &:focus {
    outline: 2px solid #0088cc;
    outline-offset: 2px;
  }
`

export const QuestionsContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 24px;
`

export const QuestionItem = styled.div`
  border-bottom: 1px solid #e5e7eb;

  &:last-child {
    border-bottom: none;
  }
`

export const QuestionHeader = styled.button`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;

  &:focus {
    outline: 2px solid #0088cc;
    outline-offset: -2px;
  }
`

export const QuestionTitle = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  flex: 1;
  padding-right: 16px;
`

export const ExpandIcon = styled.span`
  font-size: 20px;
  color: #0088cc;
  font-weight: 300;
  transition: transform 0.2s ease;
  transform: ${props => (props.isOpen ? 'rotate(45deg)' : 'rotate(0deg)')};
`

export const QuestionContent = styled.div`
  max-height: ${props => (props.isOpen ? '500px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease;
`

export const QuestionText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #4b5563;
  line-height: 1.6;
  margin: 0;
  padding-bottom: 16px;
`

export const FooterContainer = styled.div`
  padding: 24px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
`

export const FooterText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`

export const FooterLink = styled.a`
  color: #0088cc;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`
